module.exports = __webpack_public_path__ + "front/img/edm-banner-xianxia-gz.a224ef15.png";